import "./css/index.css";
import React, { FC } from "react";
import classNames from "classnames";
import { ODSCarouselNavigationProps } from "./ODSCarouselNavigation.types";
import { ODSButton, ODSRow } from "@/atoms";
import {
  getNextIndex,
  getNextDisabledValue,
  getPreviousIndex,
  getPreviousDisabledValue,
} from "./ODSCarouselNavigation.utils";

const ODSCarouselNavigation: FC<ODSCarouselNavigationProps> = ({
  className,
  dots = 0,
  activeIndex = 0,
  loop = false,
  onActiveChange,
  navigationLeftButtonProps,
  navigationRightButtonProps,
  ...rest
}) => {
  const previousDisabled = getPreviousDisabledValue(loop, dots, activeIndex);
  const nextDisabled = getNextDisabledValue(loop, dots, activeIndex);

  const handleClick = (nextIndex: number | null) => {
    if (nextIndex !== null) onActiveChange?.(nextIndex);
  };

  return (
    <ODSRow
      className={classNames("ODSCarouselNavigation", className)}
      {...rest}
    >
      <ODSButton
        onClick={() => handleClick(getPreviousIndex(loop, dots, activeIndex))}
        buttonIcon="left-condensed-standard"
        buttonType="iconOnly"
        size="small"
        variant="ghost"
        aria-label="Previous Item"
        disabled={previousDisabled}
        {...navigationLeftButtonProps}
      />
      <ODSRow className="ODSCarouselNavigation-DotContainer">
        {Array.from({ length: dots }).map((_, index) => {
          return (
            <button
              key={`ODSCarouselNavigation-item_${index}`}
              aria-label={`Item ${index + 1}`}
              aria-current={index === activeIndex ? "true" : "false"}
              onClick={() => handleClick(index)}
              className={classNames("ODSCarouselDot", {
                "ODSCarouselDot--selected": index === activeIndex,
              })}
            />
          );
        })}
      </ODSRow>
      <ODSButton
        onClick={() => handleClick(getNextIndex(loop, dots, activeIndex))}
        buttonIcon="right-condensed-standard"
        buttonType="iconOnly"
        size="small"
        variant="ghost"
        aria-label="Next Item"
        disabled={nextDisabled}
        {...navigationRightButtonProps}
      />
    </ODSRow>
  );
};

export default ODSCarouselNavigation;
